// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-designer .widget-form-container .widget-form-list .widget-form-item[data-v-5dacf052]:hover{border-width:1px}", ""]);
// Exports
module.exports = exports;
